<template>
  <TopGradientBlockLayout style="height: auto">
    <template v-slot:top>
      <MonthPicker :date="filters.date"
                   :max-date="max_date"
                   @change="changeMonth($event)"/>
    </template>
    <BudgetsStat v-if="budgetInitialized"/>
    <BudgetsNavCreate v-else/>
  </TopGradientBlockLayout>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import IconCalendar from "@/components/icons/IconCalendar";
import BudgetsNavCreate from "@/components/cabinet/Money/Budgets/BudgetsNav/BudgetsNavCreate";
import BudgetsStat from "@/components/cabinet/Money/Budgets/BudgetsStat/BudgetsStat";
import BaseButton from "@/components/UI/BaseButton";
import MonthPicker from "@/components/UI/MonthPicker";

export default {
  name: "BudgetFilters",
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/budgets', ['budgets', 'filters']),
    max_date: {
      get() {
        return this.$moment().format('YYYY-MM');
      }
    },
    budgetInitialized() {
      return !!this.budgets.data.incomes.length || !!this.budgets.data.expenses.length;
    }
  },
  components: {
    MonthPicker,
    BaseButton,
    TopGradientBlockLayout,
    BaseInput,
    IconCalendar,
    BudgetsStat,
    BudgetsNavCreate,
  },
  methods: {
    ...mapMutations('space/budgets', ['setDateFilter']),
    changeMonth(date) {
      this.setDateFilter(date)
    },
  },
  i18n: {
    messages: {
      en: {
        currentPeriodLabel: 'Current period'
      },
      ru: {
        currentPeriodLabel: 'Текущий период'
      }
    }
  }
}
</script>